import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidationLogic } from './validation-logic';
import { CustomBaseNumberPipe } from './custom-base-number.pipe';

@Pipe({
    name: `CustomCurrencyUsdPipe`
})
@Injectable()
export class CustomCurrencyUsdPipe extends CustomBaseNumberPipe implements PipeTransform {
    private get currencyDecimalPlaces(): number {
        return 2;
    }

    public transform(value: any): string {
        // see if we can parse the value to a number.
        if (!this.isFormattableNumber(value, true)) {
            throw 'value does not represent a valid number.';
        }

        // change the value to zero if it is falsy
        if (!value) {
            value = 0;
        }

        // decimal places for the currency pipe will always be 2.
        return this.formatNumericValue(value, this.currencyDecimalPlaces);
    }

    protected isValidNumberFormat(control: AbstractControl, allowNegative?: boolean): boolean {
        // the number can be formatted if it matches the decimal format (includes regular numbers).
        // use 'isNumber' so that the decimal value will round up or down properly when more decimal
        //  places are passed in.
        return ValidationLogic.isNumber(control, allowNegative);
    }

    protected formatNumericValue(value: number, decimalPlaces: number): string {
        // 'toFixed(2)' forces two decimal places.  The replace call will add in commas in the thousands place, etc.
        let stringValue: string = super.formatNumericValue(value, decimalPlaces);

        if (value >= 0) {
            // if the value is >= 0, put the dollar sign in front.
            stringValue = `$${stringValue}`;
        } else {
            // if the value is negative, place the dollar sign at index 1, after the negative sign.
            let tempArray: string[] = stringValue.split('');

            tempArray.splice(1, 0, '$');
            stringValue = tempArray.join('');
        }

        return `${stringValue}`;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/custom-currency-usd.pipe.ts